import styled from 'styled-components';
import { getChartColors } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';

export const StatCardContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.White};
  border: 1px solid ${({ theme }) => theme.colors.Grey4};
  border-radius: 8px;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  height: 100%;
`;

export const StatCardLabel = styled.span`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 13px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const StatCardValue = styled.span`
  ${({ theme }) => theme.fonts.PoppinsBold};
  font-size: 28px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StatCardSubtitle = styled.span<{ variant?: 'default' | 'error' }>`
  font-size: 12px;
  ${({ theme }) => theme.fonts.PoppinsText};
  color: ${({ theme, variant }) =>
    variant === 'error' ? getChartColors().indicator.negative : theme.colors.Grey6};
`;

type ChangeVariant = 'positive' | 'negative' | 'neutral';

export const StatCardChange = styled.span<{ variant: ChangeVariant }>`
  font-size: 12px;
  ${({ theme }) => theme.fonts.PoppinsText};
  color: ${({ variant }) => {
    const { indicator } = getChartColors();
    switch (variant) {
      case 'positive':
        return indicator.positive;
      case 'negative':
        return indicator.negative;
      case 'neutral':
        return indicator.neutral;
    }
  }};
`;
